import { useEffect, useState } from 'react';
import { Button, Row, Tabs, Typography } from 'antd';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import GeneralSettings from './GeneralSettings';
import MessageTemplates from './MessageTemplates';
import { createDefaultTemplates } from 'requests/notification';
import { toast } from 'react-toast';

const { TabPane } = Tabs;
const { Title } = Typography;

export default function WhatsappSettings() {
    const location = useLocation();
    const params = useParams();
    const navigate = useNavigate();

    const [loadingCreateTemplate, setLoadingCreateTemplate] = useState(false);

    const onCreateDefaultTemplates = async () => {
        try {
            setLoadingCreateTemplate(true);

            const res = await createDefaultTemplates();

            toast.success("Default templates are created!");
        } catch (err) {
            console.log(err.response);
        } finally {
            setLoadingCreateTemplate(false);
        }
    }

    useEffect(() => {
        if (params.service === 'whatsapp') {
            if (!params.tab) {
                navigate('/notifications/settings/whatsapp/config');
            }
        }
    }, [location.pathname]);

    return (
        <Tabs
            tabPosition="left"
            className="whatsapp"
            activeKey={params.tab}
            defaultActiveKey={params.tab}
            destroyInactiveTabPane={true}
            onChange={(key) => navigate(`/notifications/settings/whatsapp/${key}`)}
        >
            <TabPane tab="General settings" key="config">
                <GeneralSettings />
            </TabPane>

            <TabPane tab="Templates" key="templates">
                <Row justify="space-between" align="middle" className='mb-16'>
                    <Title level={4}>Message templates</Title>
                    <div>
                        <Button type="default" className='mr-8' loading={loadingCreateTemplate} onClick={onCreateDefaultTemplates}>Add Default Templates</Button>
                        <a href='https://business.facebook.com/wa/manage/message-templates' target="_blank">
                            <Button type="primary">Manage Templates</Button>
                        </a>
                    </div>
                </Row>
                <MessageTemplates />
            </TabPane>
        </Tabs>
    );
}
